import { render, staticRenderFns } from "./indexTitle.vue?vue&type=template&id=6236f2ae&scoped=true&"
import script from "./indexTitle.vue?vue&type=script&lang=js&"
export * from "./indexTitle.vue?vue&type=script&lang=js&"
import style1 from "./indexTitle.vue?vue&type=style&index=1&id=6236f2ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6236f2ae",
  null
  
)

export default component.exports